"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signedExtensions = exports.typesBundleForPolkadot = exports.typesBundle = exports.typesAlias = exports.rpc = exports.types = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ormlTypeDefinitions = require("@open-web3/orml-type-definitions");

var _utils = require("@open-web3/orml-type-definitions/utils");

var _signedExtensions = require("./signedExtensions");

var _amm = _interopRequireDefault(require("./amm"));

var _liquidStaking = _interopRequireDefault(require("./liquidStaking"));

var _loans = _interopRequireDefault(require("./loans"));

var _prices = _interopRequireDefault(require("./prices"));

var _primitives = _interopRequireDefault(require("./primitives"));

var _runtime = _interopRequireDefault(require("./runtime"));

var _parallel = _interopRequireDefault(require("./spec/parallel"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const parallelDefs = {
  loans: _loans.default,
  liquidStaking: _liquidStaking.default,
  amm: _amm.default,
  prices: _prices.default,
  primitives: _primitives.default,
  runtime: _runtime.default
};

const types = _objectSpread(_objectSpread({}, _ormlTypeDefinitions.types), (0, _utils.typesFromDefs)(parallelDefs));

exports.types = types;
const rpc = (0, _utils.jsonrpcFromDefs)(parallelDefs, _objectSpread({}, _ormlTypeDefinitions.rpc));
exports.rpc = rpc;
const typesAlias = (0, _utils.typesAliasFromDefs)(parallelDefs, _objectSpread({}, _ormlTypeDefinitions.typesAlias));
exports.typesAlias = typesAlias;

function getBundle(versioned) {
  return {
    rpc,
    instances: {
      council: ['generalCouncil']
    },
    types: [...versioned].map(version => {
      return {
        minmax: version.minmax,
        types: _objectSpread(_objectSpread({}, types), version.types)
      };
    }),
    alias: typesAlias
  };
}

const typesBundle = {
  spec: {
    parallel: getBundle(_parallel.default)
  }
}; // Type overrides have priority issues

exports.typesBundle = typesBundle;
const typesBundleForPolkadot = {
  spec: {
    parallel: getBundle(_parallel.default)
  }
};
exports.typesBundleForPolkadot = typesBundleForPolkadot;
const signedExtensions = _signedExtensions.signedExtensions;
exports.signedExtensions = signedExtensions;